export const DATAROOM_UPLOADABLE_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.txt',
  '.ppt',
  '.pptx',
  '.html',
  '.htm',
  '.md',
] as const;

export const DATAROOM_SPREADSHEET_EXTENSIONS = ['.xls', '.xlsx', '.csv'] as const;

const DATAROOM_SUPPORTED_EXTENSIONS = new Set<string>([
  ...DATAROOM_UPLOADABLE_EXTENSIONS,
  ...DATAROOM_SPREADSHEET_EXTENSIONS,
]);

export function getDataroomFileExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  return dot >= 0 ? fileName.slice(dot).toLowerCase() : '';
}

export function isSupportedDataroomFileName(fileName: string): boolean {
  const ext = getDataroomFileExtension(fileName);
  return ext !== '' && DATAROOM_SUPPORTED_EXTENSIONS.has(ext);
}

export function unsupportedDataroomFileMessage(fileName: string): string {
  const extensions = Array.from(DATAROOM_SUPPORTED_EXTENSIONS).join(', ');
  return `"${fileName}" uses an unsupported file type. Supported extensions: ${extensions}.`;
}
